import { NavLink } from 'react-router-dom';
import { useNotifications } from 'context/NotificationsContext.jsx';
import { badgeLabel } from 'lib/notifications.mjs';

/**
 * The bell, with its unread count. Rendered by both shells.
 *
 * A NavLink rather than a dropdown panel. A popover would need its own fetch, its
 * own scroll, its own empty state and its own "see all" escape hatch — a second,
 * worse copy of the notification centre that then has to be kept in step with
 * it. The badge answers "is there anything new", which is the question the
 * chrome should answer; the page answers everything else.
 *
 * The count comes from NotificationsContext, so it is the same number wherever
 * the bell is rendered and it moves the moment something is marked read.
 *
 * `variant` picks the class family — the two shells style their chrome
 * differently and always have, the same split Button makes.
 */
export default function NotificationBell({ variant = 'classic' }) {
  const { unread } = useNotifications();
  const label = badgeLabel(unread);

  return (
    <NavLink
      to='/notifications'
      className={({ isActive }) =>
        `notif-bell notif-bell--${variant}${isActive ? ' notif-bell--active' : ''}`}
      title={unread ? `${unread} unread notification${unread === 1 ? '' : 's'}` : 'Notifications'}
      aria-label={unread ? `Notifications, ${unread} unread` : 'Notifications'}
    >
      <span className='notif-bell__icon' aria-hidden='true'>🔔</span>
      {/* aria-hidden because the count is already in the link's aria-label —
          without it a screen reader reads the number twice. */}
      {label && <span className='notif-bell__badge' aria-hidden='true'>{label}</span>}
    </NavLink>
  );
}
